const tracksValidationIT = {
    "trackName": {
        "required": "Il nome del brano è obbligatorio",
        "length": "Il nome del brano deve essere più lungo di 1 e meno di 255 caratteri",
        "regexp": "Il nome del brano può consistere solo di lettere, numeri, spazi e underscore"
    },
    "mix_name": {
        "required": "Per favore, inserisci il nome del mix",
        "regexp": "Il nome del mix può consistere solo di lettere, numeri, spazi e underscore"
    },
    "artistName": {
        "required": "Per favore, seleziona l'artista"
    },
    "artistType": {
        "required": "Per favore, seleziona il tipo di artista"
    },
    "atleastOneMainArtist": {
        "required": "Almeno un artista deve essere principale"
    },
    "duplicateArtists": {
        "required": "Ci sono due o più artisti con lo stesso nome."
    },
    "publisherName": {
        "required": "Per favore, seleziona l'editore"
    },
    "publisherAuthor": {
        "required": "Per favore, inserisci il vero nome e cognome della persona."
    },
    "contributorName": {
        "required": "Per favore, seleziona il collaboratore"
    },
    "contributorRole": {
        "required": "Per favore, seleziona il ruolo del collaboratore"
    },
    "atleastOneComposer": {
        "required": "Almeno un collaboratore deve essere un compositore"
    },
    "atleastOneLyricist": {
        "required": "Almeno un collaboratore deve essere un paroliere"
    },
    "copyright": {
        "required": "Il copyright è obbligatorio",
        "regexp": "Il copyright può consistere solo di lettere, numeri, spazi e underscore"
    },
    "copyrightYear": {
        "required": "L'anno del copyright è obbligatorio",
        "regexp": "L'anno del copyright deve essere un anno valido"
    },
    "ISRC": {
        "required": "Per favore, fornisci l'ISRC o seleziona Genera ISRC",
        "regexp": "Per favore, inserisci un codice ISRC valido o lascia vuoto"
    },
    "DA_ISRC": {
        "required": "Per favore, fornisci l'ISRC Dolby Atmos o seleziona Genera ISRC",
        "regexp": "Per favore, inserisci un codice ISRC valido o lascia vuoto"
    },
    "trackLanguage": {
        "required": "La lingua del brano è obbligatoria. Per favore, seleziona la lingua del nome del tuo brano."
    },
    "trackVocals": {
        "required": "La voce del brano è obbligatoria. Per favore, seleziona la lingua delle tue voci."
    },
    "trackGenre": {
        "required": "Per favore, seleziona il genere del tuo brano."
    },
    "trackSubGenre": {
        "required": "Per favore, seleziona il sottogenere del tuo brano"
    },
    "featuringArtistMissing": {
        "required": "Il brano deve avere l'artista in evidenza elencato nel titolo correttamente assegnato a un ruolo di artista in evidenza. Si prega di modificare e inviare nuovamente."
    }
};

export default tracksValidationIT;